"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ErrorHandler = _interopRequireDefault(require("../stories/utils/ErrorHandler"));
class BlankErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorTitle: props.errorTitle ? props.errorTitle : 'We\'re sorry, but something went wrong.',
      errorMessage: props.errorMessage ? props.errorMessage : 'Please try again later. If the problem persists please contact us at <a href="#contact-us">our support page</a>.'
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error('Caught error: ', error);
    console.error('Error info: ', errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
var _default = exports.default = BlankErrorBoundary;